import React from "react";
import { Tag, Tooltip, Button, Select } from "antd";
import { EyeOutlined, EditOutlined, DeleteOutlined, SaveOutlined, CloseOutlined } from "@ant-design/icons";
const roleMap = {
  SUPPLIER: "Supplier",
  DROPSHIPPER: "Drop Shipper",
  ADMIN: "Admin",
  WARE_HOUSE: "Warehouse",
};

export const columns = ({ editingUserId, onEditClick, onSaveClick, onCancelClick, setNewRole, setNewStatus, newRole, newStatus, originalRole, originalStatus, }) => [
  {
    title: "User Name",
    key: "userName",
    render: (_, record) => `${record.firstName} ${record.lastName}`,
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Phone Number",
    dataIndex: "phoneNumber",
    key: "phoneNumber",
  },
  {
    title: "Created At",
    dataIndex: "created",
    key: "created",
    render: (value) => {
      if (!value) return "-";
      const dt = new Date(value);
      if (Number.isNaN(dt.getTime())) return "-";
      return dt.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
      });
    },
  },
  {
    title: "User Role",
    dataIndex: "role",
    key: "role",
    render: (text, record) => {
      // If it's the row being edited, display a dropdown, else display the text
      return editingUserId === record.id ? (
        <Select
          value={newRole}
          onChange={setNewRole}
          style={{ width: 120 }}
        >
          <Select.Option value="SUPPLIER">Supplier</Select.Option>
          <Select.Option value="DROPSHIPPER">Drop Shipper</Select.Option>
          <Select.Option value="ADMIN">Admin</Select.Option>
          <Select.Option value="WARE_HOUSE">Warehouse</Select.Option>
        </Select>
      ) : (
        roleMap[text]
          ? roleMap[text]
          : text
      );
    },
  },
  {
    title: "STATUS",
    dataIndex: "status",
    key: "status",
    render: (text, record) => {
      const status = text || record.status;
      let color;
      let displayStatus = status;

      if (status === "ACTIVE") {
        color = "green";
        displayStatus = "Active";
      } else if (status === "RESTRICTED" || status === "BLOCK") {
        color = "red";
        displayStatus = "Restricted";
      } else if (!status || status === "INACTIVE") {
        color = "red";
        displayStatus = "Inactive";
      } else {
        color = "red";
        displayStatus = status;
      }

      return editingUserId === record.id ? (
        <Select
          value={newStatus || "INACTIVE"}
          onChange={setNewStatus}
          style={{ width: 120 }}
        >
          <Select.Option value="ACTIVE">Active</Select.Option>
          <Select.Option value="RESTRICTED">Restricted</Select.Option>
          <Select.Option value="BLOCK">Block</Select.Option>
          <Select.Option value="PENDING">Pending</Select.Option>
          <Select.Option value="INACTIVE">Inactive</Select.Option>
        </Select>
      ) : (
        <Tag color={color}>{displayStatus}</Tag>
      );
    },
  },
  {
    title: "Actions",
    key: "actions",
    render: (text, record) => (
      <div>
        {editingUserId === record.id ? (
          <div>
            <Tooltip title="Save">
              <Button
                icon={<SaveOutlined />}
                onClick={() => onSaveClick(record)}
                style={{ marginRight: 8 }}
              />
            </Tooltip>
            <Tooltip title="Cancel">
              <Button
                icon={<CloseOutlined />}
                onClick={() => onCancelClick(record)}
                style={{ marginRight: 8 }}
              />
            </Tooltip>
          </div>
        ) : (
          <Tooltip title="Edit">
            <Button
              icon={<EditOutlined />}
              onClick={() => onEditClick(record)}
              style={{ marginRight: 8 }}
            />
          </Tooltip>
        )}
      </div>
    ),
  },
];
